import { render } from "./EditCollectionModal.vue?vue&type=template&id=6b31b6e1&scoped=true"
import script from "./EditCollectionModal.vue?vue&type=script&lang=js"
export * from "./EditCollectionModal.vue?vue&type=script&lang=js"

import "./EditCollectionModal.vue?vue&type=style&index=0&id=6b31b6e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b31b6e1"]])

export default __exports__